import { createFileRoute, notFound } from '@tanstack/react-router';

import { buildGuards, hasPermission } from '@mint-lib/routing-guards';
import { z } from 'zod';

import { Layout } from '@myn/permissions/routes';

const guard = buildGuards(hasPermission('usersPermissionsFeature:view'));

export const Route = createFileRoute(
  '/_secured/company-profile/users-management',
)({
  async beforeLoad({ context }) {
    const guardsContext = await context.getGuardContext();
    if (!guard(guardsContext)) {
      throw notFound();
    }
  },
  async loader({ context }) {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/permissions');

    await context.getInstance('i18n', '@mint-lib/labels-table');

    const title = i18n.t('Users Management | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
  validateSearch: z.object({
    limit: z.number().optional(),
    offset: z.number().optional(),
    ordering: z.string().optional(),
    search: z.string().optional(),
  }),
  component: Layout,
});
